import { render, staticRenderFns } from "./MenuItemComponent.vue?vue&type=template&id=cf6562a4&"
import script from "./MenuItemComponent.vue?vue&type=script&lang=ts&"
export * from "./MenuItemComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports